(() => {
  'use strict';
  const root = document.querySelector('#dc-letters');
  if (!root) return;
  const text = (tag, value, className) => {
    const el = document.createElement(tag); el.textContent = value;
    if (className) el.className = className;
    return el;
  };
  const makeLink = (url, label) => { const el = text('a', label); el.href = url; return el; };
  const status = root.querySelector('.share-status');
  const copy = root.querySelector('[data-copy-link]');
  if (copy) {
    copy.hidden = !navigator.clipboard?.writeText;
    copy.addEventListener('click', async () => {
      try { await navigator.clipboard.writeText(location.origin + location.pathname); status.textContent = 'Link copied.'; }
      catch { status.textContent = 'Could not copy. You can copy the address from your browser.'; }
    });
  }
  const share = root.querySelector('[data-share-letter]');
  if (share && navigator.share) {
    share.hidden = false;
    share.addEventListener('click', async () => {
      try { await navigator.share({ title: document.querySelector('h1').textContent, url: location.origin + location.pathname }); }
      catch (error) { if (error.name !== 'AbortError') status.textContent = 'Sharing is unavailable. Try Copy link.'; }
    });
  }
  async function loadLetters() {
    let next = root.dataset.lettersIndex;
    const items = [], visited = new Set();
    while (next) {
      const url = new URL(next, location.origin);
      if (url.origin !== location.origin || visited.has(url.href)) throw new Error('Invalid archive response');
      visited.add(url.href);
      const response = await fetch(url.href, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Archive unavailable');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const data = JSON.parse(doc.querySelector('#letters-data').textContent);
      if (!Array.isArray(data.letters)) throw new Error('Invalid archive response');
      items.push(...data.letters); next = data.next;
    }
    return [...new Map(items.map(item => [item.handle, item])).values()].sort((a,b) => b.date.localeCompare(a.date));
  }
  if (root.dataset.letterHandle) return;
  loadLetters().then(items => {
    const form = root.querySelector('.archive-filters');
    if (!form) return;
    const search = form.querySelector('[name=q]'), year = form.querySelector('[name=year]'), topic = form.querySelector('[name=topic]');
    const original = root.querySelector('.archive-original'), results = root.querySelector('.filtered-letters'), count = root.querySelector('.filter-status'), more = root.querySelector('.load-more');
    const addOption = (select, value) => { const el = text('option', value); el.value = value; select.append(el); };
    [...new Set(items.map(item=>item.date.slice(0,4)))].sort().reverse().forEach(value=>addOption(year,value));
    [...new Set(items.map(item=>item.topic))].sort().forEach(value=>addOption(topic,value));
    const params = new URLSearchParams(location.search);
    search.value = params.get('q') || ''; year.value = params.get('year') || ''; topic.value = params.get('topic') || '';
    let matches = [], visible = 0;
    const normalize = value => value.normalize('NFKD').replace(/[\u0300-\u036f]/g,'').toLocaleLowerCase();
    function appendResults(moveFocus = false) {
      const firstNew = visible;
      matches.slice(visible,visible+20).forEach(item => {
        const row = text('article','','archive-row');
        const date = text('time',new Date(item.date+'T12:00:00').toLocaleDateString('en-US',{year:'numeric',month:'long',day:'numeric'})); date.dateTime = item.date;
        const content = text('div',''), h = text('h3',''); h.append(makeLink(item.url,item.title));
        const summary = new DOMParser().parseFromString(item.summary, 'text/html').documentElement.textContent;
        content.append(h,text('p',summary));
        const arrow = makeLink(item.url,'↗'); arrow.className='row-arrow'; arrow.setAttribute('aria-label','Read '+item.title);
        row.append(date,content,arrow); results.append(row);
      });
      visible = Math.min(visible+20,matches.length); more.hidden=visible>=matches.length;
      if (moveFocus) {
        results.children[firstNew]?.querySelector('h3 a').focus();
        count.textContent = `${matches.length} letters found. Showing ${visible} of ${matches.length}.`;
      }
    }
    function filter(updateUrl = true) {
      const words = normalize(search.value.trim()).split(/\s+/).filter(Boolean);
      const active = words.length || year.value || topic.value;
      if (root.querySelector('[data-starters]')) root.querySelector('[data-starters]').hidden=!!active;
      original.hidden=!!active; results.hidden=!active; more.hidden=true; results.replaceChildren();
      if (active) {
        matches=items.filter(item => (!year.value || item.date.startsWith(year.value)) && (!topic.value || item.topic===topic.value) && words.every(word=>normalize(item.title+' '+item.summary+' '+item.text).includes(word)));
        count.textContent=matches.length ? `${matches.length} ${matches.length===1?'letter':'letters'} found.` : 'No letters match. Try another word, year, or topic.';
        visible=0; appendResults();
      } else { count.textContent='Browse by date, or search all '+items.length+' letters.'; }
      if (updateUrl) {
        const url = new URL(location.href);
        ['q','year','topic'].forEach(key => { const value=form.elements[key].value.trim(); value ? url.searchParams.set(key,value) : url.searchParams.delete(key); });
        if (active) url.searchParams.delete('page');
        history.replaceState(null,'',url);
      }
    }
    form.addEventListener('submit',event=>{event.preventDefault();filter();});
    year.addEventListener('change',()=>filter()); topic.addEventListener('change',()=>filter());
    let timer; search.addEventListener('input',()=>{clearTimeout(timer);timer=setTimeout(()=>filter(),180);});
    form.querySelector('.filter-clear').addEventListener('click',()=>{search.value='';year.value='';topic.value='';filter();search.focus();});
    more.addEventListener('click',()=>appendResults(true)); filter(false); form.hidden=false;
  }).catch(() => {
    const el=root.querySelector('.filter-status');
    if (el) {
      el.textContent='Search is temporarily unavailable. You can still browse the letters by date below. ';
      const retry = text('button','Retry search','filter-retry'); retry.type='button';
      retry.addEventListener('click',()=>location.reload()); el.append(retry);
    }
  });
})();
